import { format } from "date-fns";
import { usePost } from "../../api";

interface CreatemembershipBookingInput {
  spaceId: string;
  startDate: Date;
  endDate: Date;
}

export function useSubmitMembershipBooking() {
  const post = usePost();

  return async (
    partnerId: string,
    subscriptionId: string,
    input: CreatemembershipBookingInput
  ) => {
    await post(
      `/api/v3/portal/partners/${partnerId}/subscriptions/${subscriptionId}/bookings`,
      {
        space_id: input.spaceId,
        start_date: format(input.startDate, "yyyy-MM-dd"),
        end_date: format(input.endDate, "yyyy-MM-dd"),
      }
    );
  };
}
